import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import useSocialHandles from "../Hooks/useSocialHandles";
import useNewsletter from "../Hooks/useNewsletter";

const Footer = () => {
  const { data, loading, error } = useSelector((state) => state.api);
  const [expandedSection, setExpandedSection] = useState(null);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { subscribe, loading: subscribeLoading, error: subscribeError } = useNewsletter();
  const [email, setEmail] = useState("");
  const { socialHandles} = useSocialHandles();

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };
  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      return alert("Please enter a valid email address.");
    }
    const result = await subscribe(email);
    if (result?.success) {
      setEmail(""); // Clear the input field on successful subscription
    }
  };
  if (loading || !data?.footer_links) return <div></div>;
  if (error) return <div>Error loading navigation links</div>;

  const contactUsLinks = data.footer_links?.filter(
    (link) => link.content_order >= 0 && link.content_order <= 3
  );
  const customerCareLinks = data.footer_links?.filter(
    (link) => link.content_order >= 4 && link.content_order <= 7
  );
  const informationLinks = data.footer_links?.filter(
    (link) => link.content_order >= 8 && link.content_order <= 15
  );
  const newsletterSignup = data.footer_links?.filter(
    (link) => link.content_order >= 16 && link.content_order <= 17
  );
  
  const copyright = data.footer_links?.find(
    (link) => link.content_order === 21
  );

  const renderSection = (sectionName, links, isContactUs = false) => (
    <div>
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => toggleSection(sectionName)}
      >
        <span className="font-semibold text-sm uppercase mb-4">
          {sectionName}
        </span>
        {isMobile && (
          <span>
            {expandedSection === sectionName ? (
              <i class="fa-solid fa-minus text-sm"></i>
            ) : (
              <i class="fa-solid fa-plus text-sm"></i>
            )}
          </span>
        )}
      </div>
      <ul
        className={`transition-all ${
          expandedSection === sectionName || !isMobile ? "block" : "hidden"
        }`}
      >
        {links?.map((link, index) => (
          <li
            key={link.id}
            className={`mb-2 flex items-center ${
              index === 0 ? "hidden" : "text-xs mb-3"
            }`}
          >
            {isContactUs && link.extras && (
              <i className={`${link.extras} mr-2 text-base`}></i> // Render icon for Contact Us
            )}
            {link.extras && !isContactUs ? (
              <Link to={link.extras} className="hover:underline">
                {link.name}
              </Link>
            ) : (
              <span>{link.name}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <>
      <footer className="bg-gray-100 py-8 pt-15 mt-10 ">
        <div className="container mx-auto px-4 lg:px-52">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
            {renderSection("Contact Us", contactUsLinks, true)}
            {renderSection("Customer Care", customerCareLinks)}
            {renderSection("Information", informationLinks)}
            <div>
              <div className="font-semibold text-sm uppercase mb-4">
                Newsletter Signup
              </div>
              <form
                className="flex justify-between mt-2 border border-black rounded-xl p-[3px] w-80"
                onSubmit={handleSubscribe}
              >
                <input
                  type="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="border-0 w-full sm:w-auto p-2 text-sm bg-gray-100 placeholder:text-sm focus:outline-none focus:bg-transparent focus:shadow-none"                />
                <button
                  type="submit"
                  className="p-2 px-3 bg-black text-white text-sm font-semibold rounded-xl"
                  disabled={subscribeLoading}
                >
                  {subscribeLoading ? "Loading..." : "Subscribe"}
                </button>
              </form>
              <div className="flex justify-between mt-4">
                <div className="space-x-4">
                  {socialHandles?.map((item) => (
                    <a
                      href={item.url}
                      key={item.id}
                      className="text-black hover:text-gray-600"
                    >
                      <i className={`${item.icon_code} text-lg`}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {copyright && (
        <div className="text-sm py-4 flex justify-end px-5 bg-white text-gray-600">
          {copyright.name}
        </div>
      )}
    </>
  );
};

export default Footer;
